import { useState } from 'react'

import estimateRefundIcon from '../../../assets/ApplicationIcons/estimateRefundIcon.png'

export function ApplicationStep8({ step, estimateRefund, setStep, handleSubmitApplication }) {
  const [agreeToTerms, setAgreeToTerms] = useState(false)
  const [submittingApplication, setSubmittingApplication] = useState(false)

  const handleSubmittingApplication = async () => {
    setSubmittingApplication(true)
    await handleSubmitApplication('Pre-Qualified-N')
    setSubmittingApplication(false)
  }

  return (
    <div className='lg:w-1/2 w-11/12 h-full flex flex-col items-center lg:justify-center mt-10 mb-10'>
      {estimateRefund > 0 && (
        <div className='mr-auto h-fit p-6 rounded-lg shadow-lg bg-gray-50 flex items-center gap-4 mb-4'>
          <div className='w-12 h-12 flex items-center justify-center rounded-full bg-secondaryColor object-contain'>
            <img 
              className='w-8 h-8' 
              src={estimateRefundIcon} 
              alt='Estimate Icon' 
            />
          </div>
          <div className='flex flex-col'>
            <p className='text-gray-600 text-sm font-medium'>Current Estimate</p>
            <p className='text-xl font-bold text-gray-900'>
              ${Number(estimateRefund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
          </div>
        </div>
      )}
      <div className='w-full border border-black rounded-lg p-5 bg-gray-200'>
        <p>You agree to receive promotional and status update alert messages sent via an autodialer from <span className='text-blue-600 underline'>SETCPROS.com</span>. You also agree to the <span className='text-blue-600 underline'>terms of service</span> and <span className='text-blue-600 underline'>privacy policy</span>.</p>
        <p>This agreement isn't a condition of any purchase. Message frequency varies. Message and data rates may apply. Reply STOP to opt out; HELP for more information.</p>
      </div>
      <div onClick={() => setAgreeToTerms(!agreeToTerms)} className='flex flex-row self-start mt-2 gap-2 mb-4 cursor-pointer'>
        <input
          type='checkbox'
          checked={agreeToTerms}
          onChange={(e) => setAgreeToTerms(e.target.checked)}
        />
        <p>I accept the Terms and Conditions.</p>
      </div>
      <div className='flex flex-row items-center gap-4'>
        <button
          onClick={() => setStep(step - 1)}
          className='flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition-colors duration-200 mb-4 mt-10 bg-red-500 hover:bg-red-600'
        >
          Back
        </button>
        <button
          disabled={!agreeToTerms || submittingApplication}
          onClick={handleSubmittingApplication}
          className={`flex flex-row items-center gap-2 px-8 py-2 text-white rounded-md transition-colors duration-200 mb-4 mt-10 ${!agreeToTerms || submittingApplication ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}
        >
          Submit
        </button>
      </div>
      {submittingApplication && (
        <div className='flex flex-row items-center justify-center gap-2 -mb-5'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
          <p>Submitting Application...</p>
        </div>
      )}
    </div>
  )
}